import type {
  ChangelogNotesAudience,
  ChangelogRoundupCadence,
  ChangelogUserFacingAnnouncements,
} from "@/features/changelog/api/changelog.api";

/** Mirrors the bounds the settings schema enforces, so the inputs agree with it. */
export const LIMITS = {
  autoPublishDelayMinutes: { min: 0, max: 24 * 60 },
  minItemsToAutoPublish: { min: 1, max: 20 },
  minDeploysToAutoCompose: { min: 1, max: 20 },
  roundupAutoSendDelayMinutes: { min: 0, max: 7 * 24 * 60 },
  sprintLengthDays: { min: 1, max: 90 },
  sprintAnchorNumber: { min: 0, max: 999 },
  maxItemsPerSection: { min: 1, max: 50 },
} as const;

export const CADENCES: ChangelogRoundupCadence[] = ["WEEKLY", "FORTNIGHTLY", "SPRINT", "MANUAL"];
export const AUDIENCES: ChangelogNotesAudience[] = ["USER_FACING", "TECHNICAL"];
export const USER_FACING_GATES: ChangelogUserFacingAnnouncements[] = [
  "HOLD",
  "BIG_NEWS_ONLY",
  "EVERYTHING",
];
